export const iconFontAwesomeChildhoodBath = (
	<i className="fa-solid fa-bath"></i>
);
